/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_RegionInputs */

const en_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const es_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Región`)
};

const fr_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Région`)
};

const de_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const ja_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地域`)
};

const zh_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产区`)
};

const ar_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنطقة`)
};

const id_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wilayah`)
};

const it_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regione`)
};

const ru_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регион`)
};

const pt_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Região`)
};

const ko_field_region = /** @type {(inputs: Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생산 지역`)
};

/**
* | output |
* | --- |
* | "Region" |
*
* @param {Field_RegionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_region = /** @type {((inputs?: Field_RegionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_RegionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_region(inputs)
	if (locale === "es") return es_field_region(inputs)
	if (locale === "fr") return fr_field_region(inputs)
	if (locale === "de") return de_field_region(inputs)
	if (locale === "ja") return ja_field_region(inputs)
	if (locale === "zh") return zh_field_region(inputs)
	if (locale === "ar") return ar_field_region(inputs)
	if (locale === "id") return id_field_region(inputs)
	if (locale === "it") return it_field_region(inputs)
	if (locale === "ru") return ru_field_region(inputs)
	if (locale === "pt") return pt_field_region(inputs)
	return ko_field_region(inputs)
});